/*
 * bachgold-cart-drawer-slots.js
 * --------------------------------------------------------------------
 * Fängt Clicks auf Slot-Add-Buttons im Cart-Drawer ab (Phase 5.8b+):
 *   - [data-bg-cd-add] mit data-variant-id attribute
 *
 * Flow: fetch /cart/add.js mit sections param -> CartDrawer.renderContents
 * Das komplette drawer__inner (inkl. Slot, Items, Progress-Bar, Totals)
 * wird vom CartDrawer neu gerendert. Slot verschwindet automatisch,
 * sobald das Produkt im Cart ist (Liquid-Check in cart-drawer.liquid).
 *
 * Event-Delegation auf document.body -> funktioniert auch nach jedem
 * Re-render ohne Re-Bind.
 * --------------------------------------------------------------------
 */
(function () {
  'use strict';

  function resolveCartAddUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root.replace(/\/$/, '') + '/cart/add.js';
    }
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url;
    }
    return '/cart/add.js';
  }

  function handleClick(event) {
    var btn = event.target.closest('[data-bg-cd-add]');
    if (!btn) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    if (btn.hasAttribute('aria-busy')) return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    var cartDrawer = document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      var sections = cartDrawer
        .getSectionsToRender()
        .map(function (s) { return s.id; })
        .join(',');
      if (sections) {
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
      }
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }
    }

    fetch(resolveCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          // Shopify-Fehler (z.B. Variant nicht verfuegbar)
          console.warn('[cart-drawer-slot] cart-add abgelehnt:', response);
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
          cartDrawer.renderContents(response);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          // Fallback: kompletter Reload wenn wir keine sections haben
          setTimeout(function () { window.location.reload(); }, 50);
        } else {
          window.location.reload();
        }
        // Attributes werden durch renderContents implizit zurueckgesetzt
      })
      .catch(function (err) {
        console.warn('[cart-drawer-slot] Cart-Add fehlgeschlagen:', err);
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.body.addEventListener('click', handleClick);
    });
  } else {
    document.body.addEventListener('click', handleClick);
  }
})();
